<h2 mat-dialog-title i18n>Register Local Credential</h2>
<form [formGroup]="localForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>Username</mat-label>
      <input matInput formControlName="username" required>
      @if (localForm.get('username')?.hasError('required')) {
        <mat-error i18n>Username is required</mat-error>
      }
    </mat-form-field>

    <!-- Show passwordOptions only if isForRemoteUser is true -->
    @if (isForRemoteUser) {
      <mat-form-field appearance="outline" class="w-full">
        <mat-label i18n>Password Options</mat-label>
        <mat-select formControlName="passwordOptions">
          <mat-option value="customPassword" i18n>Set a password on behalf of the user</mat-option>
          <mat-option value="letTheUserChooseOne" i18n>Send an email and let the user set a password</mat-option>
        </mat-select>
      </mat-form-field>
    }

    <!-- Show password field based on the conditions defined in updatePasswordFieldVisibility() -->
    @if (!isForRemoteUser || localForm.get('passwordOptions')?.value === 'customPassword') {
      <div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label i18n>Password</mat-label>
          <input matInput type="password" autocomplete="new-password" formControlName="password" required>
          @if (localForm.get('password')?.hasError('required')) {
            <mat-error i18n>
              Password is required
            </mat-error>
          }
        </mat-form-field>
        <p>
          <app-password-strength [control]="localForm.get('password')"></app-password-strength>
        </p>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label i18n>Re-type Password</mat-label>
          <input matInput type="password" formControlName="passwordConfirmation" required autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
          @if (localForm.get('passwordConfirmation')?.hasError('required')) {
            <mat-error i18n>
              Re-type Password is required
            </mat-error>
          }
        </mat-form-field>
        @if (localForm.hasError('mismatch')) {
          <div i18n>
            Passwords do not match.
          </div>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="localForm.invalid" (click)="onSubmit()" i18n>Submit</button>
  </mat-dialog-actions>
</form>
